export const JSM_HR_EXPANSION_SPOTLIGHT_MESSAGE = 'JsmHRExpansionExperimentSpotlight';
